import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { getEmailList, reSendEmail } from "../../crud/alarm.crud"
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal";


const initSearchCondition = {
  companyName: '',
  startDate: '',
  sendDate: '',
  endDate: '',
  subject: '',  
}


const EmailShippingManagement = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);  
  const [isLoading, setIsLoading] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);  
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState('')
  const [modalShow, setModalShow] = useState(false)
  const [type, setType] = useState('all')
  const [listCount, setListCount] = useState(0)
  const [page, setPage] = useState(1)


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
      if (scrollPosition >= scrollHeight - 1) {
        getDataList(searchCondition);
      }
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const sendEmail = async (id) => {
    const params = {
      id: id
    }
    const rs = await reSendEmail(params)
    if (rs.data?.code == '0000') {
      alert('정상적으로 발송했습니다.')
    }
  }

  const getDataList = async () => {

    if (isLoading || isListEnd) {
      return;
    }    

    setIsLoading(true)
    
    const params = {      
      company_name : searchCondition?.companyName || '',      
      subject : searchCondition?.subject || '',
      start_date: searchCondition?.sendDate ? moment(searchCondition?.sendDate, 'YYYY-MM-DD').format('YYYY-MM-DD'): '',
      end_date: searchCondition?.sendDate ? moment(searchCondition?.sendDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD') : '',
      page: page,
    }

    const rs = await getEmailList(params)
    if (rs.data?.results) {
      setListCount(rs.data.count)
      const content = rs.data?.results        
      const new_list = [...dataList, ...content]
      setDataList(new_list)
      if (new_list.length >= rs.data.count) {
        setIsListEnd(true)
      }        
      setPage(page + 1)
    }
    setIsLoading(false)
  }

  const changeType = (type) => {
    setType(type)
  }

  const resetSearchCondition = () => {
    setSearchCondition(initSearchCondition)
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const modalOpen = (id) => {
    setSelectedCompany(id)
    setModalShow(true)
  }

  const modalClose = () => {
    setSelectedCompany('')
    setModalShow(false)
  }

  const deleteCompany = async () => {
    const params = {
      company: selectedCompany
    }
    const rs = await console.log(params)
    console.log(rs)
  }

  const excelDownload = async () => {
    const params = {

    }
    const rs = await console.log(params)
    console.log(rs)
  }

  const onSearch = async () => {
    getDataList()   
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Email 발송 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="메시지 관리" breadcrumbItem="Email 발송 관리" />

          <div className="d-flex w-100 gap-30 align-items-center mb-3">
            <div className="email-rightbar flex-grow-1">
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                            changeSearchCondition('companyName', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">제목 검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={searchCondition.subject} onChange={(e) => {
                            changeSearchCondition('subject', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">발송일자</td>
                        <td className="col-20">
                          <input className="waver-input-box w-100 border-radius-0" type="date" value={searchCondition.sendDate} onChange={(e) => {
                            changeSearchCondition('sendDate', e.target.value);
                          }} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {
                  setDataList([])                              
                  setIsListEnd(false)
                  setIsLoading(false)
                  if (page != 1){
                    setPage(1)     
                  }else{
                    onSearch()
                  }    
              }}>
                검색
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2 margin-top-18">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">Email 발송 목록</span> [ 건수 : {listCount}건 ]</p>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                    <div className="table-responsive">
                      <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">발송일시</th>
                            <th scope="col">상호</th>
                            <th scope="col">수신Email</th>
                            <th scope="col">메일 종류</th>
                            <th scope="col">첨부파일</th>
                            <th scope="col">이메일 제목</th>
                            <th scope="col">재발송</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr className="pointer" key={item.id + '_' + index} >
                                <td>{moment(item.created_at).format('YYYY-MM-DD HH:mm')}</td>
                                <td>{item.company_name}</td>
                                <td>{item.email}</td>
                                <td>{item.type}</td>
                                <td>{item.file_name}</td>                                
                                <td>{item.subject}</td>                                
                                <td>
                                  <button style={{ width: 135, height: 29 }} type="button" className="custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 button-border secondary-text white-bg" 
                                  onClick={() => {                                    
                                    sendEmail(item.id)
                                  }}>
                                    이메일 재발송
                                  </button>
                                </td>
                              </tr>
                            )
                          })
                          }
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'3%'}></img>
                  </div>}
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal title={'거래처 삭제'} show={modalShow} onHide={modalClose} size="sm">
        <p>선택된 거래처가 삭제됩니다. 정말 삭제 하시겠습니까?</p>
        <div className="d-flex justify-content-end">
          <button type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            deleteCompany()
          }}>
            삭제
          </button>
          <button type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose()
          }}>
            취소
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default EmailShippingManagement
